import React, {useRef, useEffect} from "react";
import cx from "classnames";

import styles from './CounterCard.module.scss';

type CounterCardProps = {
    time: string | number;
    isSmall?: boolean;
};

function CounterCard({ time, isSmall }: CounterCardProps) {

    const cardRef = useRef<HTMLDivElement | null>(null);
    const displayValue = isSmall ? String(time) : String(time).padStart(2, '0');

    useEffect(() => {

        const card = cardRef.current;

        if (!card) return;

        const currentElement = card.getElementsByClassName(styles.topHalf)[0];

        const currTime = currentElement?.textContent;

        const topHalf = card.getElementsByClassName(styles.topHalf)[0];
        const bottomHalf = card.getElementsByClassName(styles.bottomHalf)[0];
        const topFlip = document.createElement("div");
        const bottomFlip = document.createElement("div");

        topFlip.classList.add(styles.topFlip);

        if (isSmall) {
            topFlip.classList.add(styles.topFlipSmall);
        }

        topFlip.textContent = currTime;

        bottomFlip.classList.add(styles.bottomFlip);

        if (isSmall) {
            bottomFlip.classList.add(styles.bottomFlipSmall);
        }

        topFlip.addEventListener("animationstart", () => {
            if (topHalf){
                topHalf.textContent = String(time);
            }
        });

        topFlip.addEventListener("animationend", () => {
            topFlip.remove();
            bottomFlip.textContent = String(time);
        });

        bottomFlip.addEventListener("animationend", () => {
            if (bottomHalf){
                bottomHalf.textContent = String(time);
                bottomFlip.remove();
            }
        });

        card.appendChild(topFlip);
        card.appendChild(bottomFlip);

    }, [isSmall, time]);

    return (
        <div className={cx(styles.flipCard, {
            [styles.flipCardSmall]: isSmall,
        })} ref={cardRef}>
            <div className={cx(styles.topHalf, {
                [styles.topHalfSmall]: isSmall,
            })}>{displayValue}</div>
            <div className={cx(styles.bottomHalf, {
                [styles.bottomHalfSmall]: isSmall,
            })}>{displayValue}</div>
        </div>

    );
}

export default CounterCard;
